module.exports = __webpack_public_path__ + "static/img/601617348769.16420c5c.jpg";